/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, February 2021
 */

import React from 'react';
import VerifyDocument from './VerifyDocument';
import ServicesLayout from '../../components/ServicesLayout';
import { isUserLoggedIn } from '../../lib/utils';


const title = 'WODGiK - Weryfikator dokumentów cyfrowych';


export default {

  path: '/verifyDocument/',

  async action(ctx) {
    const { params, store, query } = ctx;

    // get store
    const state = await store.getState();

    // checks is u're logged in
    const isUserLogged = isUserLoggedIn(state, query);
    if (!(isUserLogged === true)) {
      return isUserLogged;
    }
    return {
      title,
      component: <ServicesLayout absoluteFooter>
        <VerifyDocument />
      </ServicesLayout>,
    };
  },
};



// WEBPACK FOOTER //
// src/routes/verifyDocument/index.js